import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import { PRTimesheetFilters } from './TimesheetFilters';

const PRTimesheetParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { setValue } = useFormContext<PRTimesheetFilters>();

  const clearParam = (param: string) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.delete(param);

    setSearchParams(newSearchParams);
  };

  useEffect(() => {
    let value = searchParams.get('submittedID');
    if (value) {
      setValue('submittedID', value);
      clearParam('submittedID');
    }
  }, [searchParams]);

  return <span />;
};

export default PRTimesheetParams;
